// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import WeuiVue from 'weui-design-vue'
import '../static/resources/weui-design-vue.css'
import '../static/css/quill.bubble.css';
import '../static/css/global.less'

import Antd from 'ant-design-vue'
Vue.use(Antd);

import VueLoadmore from 'vuejs-loadmore';
Vue.use(VueLoadmore)

import components from './page/components/components'
Vue.use(components)


import $ from 'jquery'
global.$ = global.jQuery = $;

import adminApi from './util/com.js';
Vue.prototype.comm = adminApi;

import axios from 'axios';
axios.defaults.baseURL = adminApi.apiUrl;

Vue.use(WeuiVue);

import VConsole from 'vconsole';

if (adminApi.environmentType === 'test' && location.href.indexOf('localhost') == -1) {
    const vConsole = new VConsole()
    Vue.use(vConsole)
}

// 请求拦截-------
axios.interceptors.request.use(function (config) {
    var token = adminApi.foowwLocalStorage.get('token')
    if (token) config.headers.common['Authorization'] = 'Bearer ' + token;
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 响应拦截--------
axios.interceptors.response.use(function (response) {
    if (response.data.code == 1008) {
        localStorage.removeItem('token');
        router.push('/login')
    }
    return response.data;
}, function (error) {
    var res = error.response.data;
    return Promise.reject(res);
});

Vue.prototype.axios = axios;


// 路由守卫
router.beforeEach((to, from, next) => {
    if (to.query.inviteCode) {
        // 这是分享链接
        adminApi.saveInviteInfo(axios, to.fullPath, to.query.inviteCode)
    }

    if (to.path == '/applicant' && to.query.hasEdit != 1) {
        if (from.path == '/order_detail') {
            return next({
                path: '/order',
                replace: true
            })
        }
    }

    if (to.path == '/supplement') {
        if (from.path == '/order_detail' && !to.query.orderCode) {
            return next({
                path: '/order',
                replace: true
            })
        }
    }

    //   if (to.path == '/order_compose') {
    //     if (from.path == '/order_detail') {
    //       return next({
    //         path: '/order',
    //         replace: true
    //       })
    //     }
    //   }



    next();
})

Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js